import Slider from 'react-slick'

import 'common/styles/vendors/slick-carousel_1.6.0_slick.min.css'
import { settings, slides } from './utils/BannerSliderUtils'
import style from './BannerSlider.module.scss'

// баннер на главной странице
export function BannerSlider() {
  return (
    <Slider {...settings}>
      {slides.map(item => (
        <div className='slideWrap' key={item.img}>
          <div
            className={style.slide}
            style={{
              backgroundImage: `url(${item.img})`,
            }}
          />
        </div>
      ))}
    </Slider>
  )
}
